import React, { useEffect } from 'react';

const Impressum = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="max-w-4xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
      <h1 className="text-4xl font-serif font-bold text-stone-900 dark:text-stone-100 mb-8">Impressum</h1>
      <div className="prose prose-stone dark:prose-invert max-w-none text-stone-700 dark:text-stone-300 space-y-2">
        <h2 className="text-2xl font-semibold mb-4 mt-8 text-stone-800 dark:text-stone-200">Angaben gemäß § 5 TMG</h2>
        <p>Sören Padel<br />Örträsk 48<br />935 93 Norsjö (Schweden)</p>
        <h2 className="text-2xl font-semibold mb-4 mt-8 text-stone-800 dark:text-stone-200">Verantwortlich für den Inhalt</h2>
        <p>Sören Padel</p>
        <h2 className="text-2xl font-semibold mb-4 mt-8 text-stone-800 dark:text-stone-200">Kontakt</h2>
        <p>Tel. +46 (0) 7222 61506<br />E-Mail: admin@liedzeit.de<br />Website: www.liedzeit.de</p>
      </div>
    </div>
  );
};

export default Impressum;
